  /* eslint-disable react/jsx-no-constructed-context-values */
  /* eslint-disable react/prop-types */
  import React, { useState, useContext, createContext } from 'react';

  const TenantContext = createContext();

  export const TenantProvider = ({ children }) => {
    const [selectedTenant, setSelectedTenant] = useState('');

    return (
      <TenantContext.Provider value={{ selectedTenant, setSelectedTenant }}>
        {children}
      </TenantContext.Provider>
    );
  };

  export const useTenant = () => useContext(TenantContext);
